<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Projects</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-1">
          <v-btn color="primary" small to="/new-project">
            <v-icon left dark>mdi-plus</v-icon>New Project
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="recordsData"
              :search="search"
            >
             <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/projects/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

                <!-- action template -->
                <template v-slot:item.employees="{ item }">
                <v-btn color="blue darken-1" text :to="`/projects/employees/${item.id}`" 
                  ><v-icon left>mdi-account-group</v-icon> Employees
                </v-btn>
              </template>
              <!-- end -->

               <!-- action template -->
               <template v-slot:item.consumables="{ item }">
                <v-btn color="accent" text :to="`/projects/consumables/${item.id}`" 
                  ><v-icon left>mdi-list-box-outline</v-icon> Consumables
                </v-btn>
              </template>
              <!-- end -->

                <!-- date template -->
                <template v-slot:item.startDate="{ item }">
                {{ item.startDate | date }}
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    search: "",
    headers: [
      { text: "Project Title", value: "name" },
      { text: "Scale", value: "projectScale.Name" },
      { text: "Project Lead", value: "lead.name" },
      { text: "Start Date", value: "startDate" },
      { text: "Start Time", value: "startTime" },
      { text: "Employees", value: "employees" },
      { text: "Consumables", value: "consumables" },
      // { text: "Action", value: "action" }
      ],
      recordsData: [],
  }),
  methods: {
    getProjects() {
      var storeId = this.activeStore;
      var url = `/store-projects/${storeId}`
      const self = this;
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.recordsData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created () {
    this.getProjects();
  },
};
</script>